var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"additional-info-wrapper"},[_c('div',{staticClass:"main-item-header"},[_vm._v(" "+_vm._s(_vm.$t("BASKET.ADDITIONAL_INFORMATION"))+" ")]),_c('b-form-textarea',{attrs:{"id":"textarea","value":_vm.value,"rows":"4"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }